<template>
    <el-pagination
        background
        :layout="paginationLayout"
        :hide-on-single-page="hideOnSinglePage"
        :current-page.sync="meta.current_page"
        :page-sizes="pageSizes"
        :page-size.sync="meta.per_page"
        :total="meta.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    ></el-pagination>
</template>

<script>
    export default {
        name: 'Pagination',
        components: {},
        mixins: [],
        props: {
            meta: {
                required: true,
                type: Object,
            },
            layout: {
                type: String,
                default: 'total, sizes, prev, pager, next, jumper',
            },
            hideOnSinglePage: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                pageSizes: [10, 15, 20, 30, 40, 50],
            };
        },
        computed: {
            paginationLayout() {
                if (this.isDesktop) {
                    return this.layout;
                }

                return 'total, prev, next, jumper';
            },
        },
        watch: {
            meta: {
                handler() {
                    if (!this.pageSizes.includes(this.meta.per_page)) {
                        this.pageSizes.push(this.meta.per_page);
                    }
                },
                deep: true,
            },
        },
        methods: {
            handleSizeChange(value) {
                this.$emit('size-change', value);
            },
            handleCurrentChange(value) {
                this.$emit('current-change', value);
                this.$scrollTo(this.$parent.$el);
            },
        },
    };
</script>
